import { render, staticRenderFns } from "./VehiclePageFaq.vue?vue&type=template&id=b36524cc&"
import script from "./VehiclePageFaq.vue?vue&type=script&lang=js&"
export * from "./VehiclePageFaq.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports